var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "colorChange",
    d: "M10.1667 10.6667L10.2122 10.6444C10.3547 10.5733 10.5146 10.5444 10.673 10.5613C10.8313 10.5782 10.9815 10.6401 11.1058 10.7397C11.2301 10.8393 11.3232 10.9724 11.3742 11.1233C11.4251 11.2742 11.4318 11.4366 11.3933 11.5911L10.6067 14.7422C10.5679 14.8969 10.5744 15.0594 10.6252 15.2104C10.6761 15.3615 10.7692 15.4949 10.8935 15.5946C11.0178 15.6944 11.1682 15.7564 11.3267 15.7733C11.4852 15.7902 11.6452 15.7613 11.7878 15.69L11.8333 15.6667M21 11.5C21 12.8132 20.7413 14.1136 20.2388 15.3268C19.7362 16.5401 18.9997 17.6425 18.0711 18.5711C17.1425 19.4997 16.0401 20.2362 14.8268 20.7388C13.6136 21.2413 12.3132 21.5 11 21.5C9.68678 21.5 8.38642 21.2413 7.17317 20.7388C5.95991 20.2362 4.85752 19.4997 3.92893 18.5711C3.00035 17.6425 2.26375 16.5401 1.7612 15.3268C1.25866 14.1136 1 12.8132 1 11.5C1 8.84784 2.05357 6.3043 3.92893 4.42893C5.8043 2.55357 8.34784 1.5 11 1.5C13.6522 1.5 16.1957 2.55357 18.0711 4.42893C19.9464 6.3043 21 8.84784 21 11.5ZM11 7.33333H11.0089V7.34222H11V7.33333Z",
    stroke: "#5D605B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.1008bb8554db4c09ccfeaeca623a50d8.svg";
export { ForwardRef as ReactComponent };